"use client";

import type {
  BuilderBlock,
  BuilderContextInterface,
  RegisteredComponent,
  RegisteredComponents,
} from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const productCardContainerInputs = [
  {
    name: "title",
    type: "string",
  },
  {
    name: "ctaLabel",
    friendlyName: "Button label",
    type: "string",
  },
  {
    name: "ctaHref",
    friendlyName: "Button link",
    type: "url",
  },
  {
    name: "isTrial",
    friendlyName: "Should magento client use trial mode",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isCarousel",
    friendlyName: "Should use carousel representation",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "desktopItemCount",
    showIf: (values) => values.get("isCarousel") === true,
    friendlyName: "Number of items to show in desktop view",
    helperText: "Only numbers from 1-4 must be chosen",
    type: "number",
    min: 1,
    max: 4,
    defaultValue: 3,
  },
  {
    name: "tabletItemCount",
    showIf: (values) => values.get("isCarousel") === true,
    friendlyName: "Number of items to show in tablet view",
    helperText: "Only numbers from 1-3 must be chosen",
    type: "number",
    min: 1,
    max: 3,
    defaultValue: 2,
  },
  {
    name: "isOverflowEnabled",
    showIf: (values) => values.get("isCarousel") === true,
    friendlyName: "Show overflow of carousel items",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isControlHidden",
    showIf: (values) => values.get("isCarousel") === true,
    friendlyName: "Should hide controls",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isViewItemListEventEnabled",
    friendlyName: "Enable GTM view_item_list event",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export type ProductCardContainerBuilderProps = BuilderComponentProps<typeof productCardContainerInputs> & {
  builderBlock?: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents?: RegisteredComponents;
  attributes?: Record<string, string>;
};

export const ProductCardContainerComponent: RegisteredComponent = {
  name: "ProductCardContainer",
  component: dynamic(async () => (await import("./ProductCardContainer")).ProductCardContainer),
  inputs: productCardContainerInputs,
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
};
